import { ReactNode, useEffect } from 'react';

import { Journey } from 'Global/Journey/Types/Journey';
import { getJourneySchedule } from 'Global/JourneyElements/Api/JourneyService';
import useQueryState from 'Hooks/useQueryState';
import { appConfigStore } from 'Models/AppConfigStore';
import { isStandbyOpen } from '../Utils/isStandbyOpen';

interface ErrorState {
	type: 'error';
}

interface LoadingState {
	type: 'loading';
}

interface DataState {
	type: 'data';
	isOpen: boolean;
}

type State = LoadingState | DataState | ErrorState;

interface StandbyOpenHoursCheckerProps {
	journeys: Journey[];
	children: (state: State) => ReactNode;
}

export default function StandbyOpenHoursChecker({ journeys, children }: StandbyOpenHoursCheckerProps) {
	const { state, query } = useQueryState(async () => {
		const result = await Promise.all(journeys.map(x => getJourneySchedule(x)));

		for (const journeySchedule of result) {
			if (!isStandbyOpen(journeySchedule.departureDateTime, appConfigStore.standbyOpenHoursBeforeDeparture)) {
				return { isOpen: false };
			}
		}

		return { isOpen: true };
	});

	useEffect(() => {
		query();
	}, []);

	if (state.status === 'idle' || state.status === 'loading') {
		return <>{children({ type: 'loading' })}</>;
	}

	if (state.status === 'error') {
		return <>{children({ type: 'error' })}</>;
	}

	return <>{children({ type: 'data', isOpen: state.data.isOpen })}</>;
}
